// System
import { Button, Typography } from '@mui/material';
// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
// Redux
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/app/store';
import { useRoundsTable } from '@Modal/hooks/rounds/useRoundsTable';
// Graphql
import { useAviatorLiveRoundStatusQuery } from '@Src/generated.graphql';
// Styles
import Styles from './UpdateRoundStatusModalDialog.module.scss';

export const UpdateRoundStatusModalDialog = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { data } = useAviatorLiveRoundStatusQuery();

  const { handleUpdateRoundStatus, showRoundStatusModalDialog, setShowRoundStatusModalDialog } =
    useRoundsTable();

  const status = data?.aviatorLiveRoundStatus;

  return (
    <ClosableModal
      name="updateRoundStatusModalDialog"
      title="Confirmation"
      open={showRoundStatusModalDialog}
      onClose={() => dispatch(setShowRoundStatusModalDialog(false))}
      className={Styles.DeleteProviderModalDialog}
      sx={{ width: '592px' }}
    >
      <>
        <CreateDialogLayout>
          <Typography variant="body2">
            Are you sure you want to change status to {status === 'RUNNING' ? 'PAUSED' : 'RUNNING'}
          </Typography>
          <CreateDialogFooterLayout>
            <AtLocator type="button" name="Cancel">
              <Button
                variant="outlined"
                color="inherit"
                onClick={() => dispatch(setShowRoundStatusModalDialog(false))}
              >
                Cancel
              </Button>
            </AtLocator>
            <AtLocator type="button" name="Submit">
              <Button
                type="submit"
                color="error"
                variant="contained"
                // @ts-ignore
                onClick={() => handleUpdateRoundStatus(status === 'RUNNING' ? 'PAUSED' : 'RUNNING')}
              >
                Confirm
              </Button>
            </AtLocator>
          </CreateDialogFooterLayout>
        </CreateDialogLayout>
      </>
    </ClosableModal>
  );
};
